import React from 'react';
import SmartModal from '../../smart/modal';

export default class Modal extends SmartModal {
  renderForm() {
    return (
      <div>
        <SmartModal.FieldGroup
          type="text"
          label="Title"
          name="local_authority[title]"
          defaultValue={this.formValue('title')}
          error={this.formError('title')}
        />
      </div>
    );
  }
}
